import Archive from './special/archive.es6';
import Single from './special/single.es6';
import Form from './special/form.es6';

const list = new Archive();
const single = new Single();
const form = new Form();